import { Component, Input } from '@angular/core';
import { FairsConfiguration } from '@planone/bau365/data-access-fair-data';

@Component({
  selector: 'bau365-empty-watchlist',
  templateUrl: './empty-watchlist.component.html',
  styleUrls: ['./empty-watchlist.component.scss'],
})
export class EmptyWatchlistComponent {
  @Input() fairsConfig: FairsConfiguration | null | undefined;
  @Input() fairId?: string | null;
  @Input() discoveryHidden?: string | null;
  @Input() displayDescription?: boolean | null;
}
